<template>
    <v-row style="height: 100%">
        <v-col cols="4">
            <v-form @submit.prevent="generateReport">
                <v-card>
                    <v-card-title>
                        Received Date
                    </v-card-title>

                    <v-card-text class="d-flex flex-column">
                        <v-select 
                            v-model="selected_filter_item"
                            :items="filter_items" 
                            label="Filter by"
                            required />

                        <div class="d-flex justify-center">
                            <v-date-picker
                                v-show="selected_filter_item === 'DATE_RANGE'"
                                v-model="selected_date_range"
                                range
                                min="2012-01-01"
                                :max="getCurrentDate()"
                                :rules="[v => !v.length || 'invalid length']" />
                        </div>

                        <div class="d-flex justify-center">
                            <v-date-picker
                                v-show="selected_filter_item === 'MONTH'"
                                v-model="selected_month"
                                type="month"
                                min="2012-01"
                                :max="getCurrentMonth()" />
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn 
                            type="submit"
                            color="primary" 
                            block
                            :loading="is_report_generating">
                            Generate Report
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-col>

        <v-col cols="8">
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    <span>{{ $route.params.native_report_slug }}</span>

                    <v-btn
                        v-if="report_items.length"
                        class="mx-2"
                        fab
                        x-small
                        color="secondary"
                        @click="downloadReport">
                        <v-icon>
                            mdi-download
                        </v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-data-table
                        :headers="report_headers"
                        :items="report_items" />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import moment from "moment"
import config from "../config"
import axios from "axios"

export default {
    name: "NativeReport",
    data() 
    {
        return {
            native_report_slug: "",

            is_report_generating: false,

            filter_items: [{ text: "Date range", value: "DATE_RANGE" }, 
                { text: "Month", value: "MONTH" }],
            selected_filter_item: "DATE_RANGE",
            selected_date_range: [this.dateDifference(this.getCurrentDate(), -1, "week"), this.getCurrentDate()],
            selected_month: this.getCurrentMonth(),

            report_items: [],
        }
    },
    computed: {
        selected_start_date()
        {
            switch (this.selected_filter_item)
            {
            case "DATE_RANGE":
                if (this.selected_date_range.length === 1)
                {
                    return this.selected_date_range[0] 
                }

                return moment(this.selected_date_range[0]).isBefore(this.selected_date_range[0]) ? this.selected_date_range[1] : this.selected_date_range[1]
            case "MONTH":
                return moment(this.selected_month).startOf("month").format("YYYY-MM-DD")
            default:
                console.error("Unsupported selected_filter_item")
                return "0000-00-00"
            }
        },
        selected_end_date()
        {
            switch (this.selected_filter_item)
            {
            case "DATE_RANGE":
                if (this.selected_date_range.length === 1)
                {
                    return this.selected_date_range[0] 
                }

                return moment(this.selected_date_range[0]).isBefore(this.selected_date_range[1]) ? this.selected_date_range[1] : this.selected_date_range[0]
            case "MONTH":
                return moment(this.selected_month).endOf("month").format("YYYY-MM-DD")
            default:
                console.error("Unsupported selected_filter_item")
                return "0000-00-00"
            }
        },
        report_headers()
        {
            if (!this.report_items.length)
            {
                return []
            }

            return Object.keys(this.report_items[0]).map(key => ({
                text: key,
                sortable: true,
                value: key,
            }))
        },
    },
    methods: {
        getCurrentDate()
        {
            return moment().format("YYYY-MM-DD")
        },
        getCurrentMonth()
        {
            return moment().format("YYYY-MM")
        },
        dateDifference(date, amount, unit_of_time)
        {
            return moment(date).add(amount, unit_of_time).format("YYYY-MM-DD")
        },
        async generateReport()
        {
            try
            {
                this.is_report_generating = true

                const { data } = await axios.put(
                    `${config.QBOS}report`,
                    {
                        mode: "SYNC",
                        reports: [{
                            report_path: this.$route.params.native_report_slug,
                            extension: "json",
                            parameters: {
                                client_id: this.$store.state.auth.profile["custom:client_id"] == 999 && this.$store.state.portalsettings.client ? this.$store.state.portalsettings.client.client_id : this.$store.state.auth.profile["custom:client_id"],
                                start_date: this.selected_start_date,
                                end_date: this.selected_end_date,
                            },
                        }],
                    },
                    { params: { Authorization: `Bearer ${this.$store.state.auth.idToken}` } },
                )

                this.report_items = data
            }
            catch (error)
            {
                console.error(error)
            }
            finally
            {
                this.is_report_generating = false
            }
        },
        downloadReport()
        {
            try
            {
                const url = new URL(`${config.QBOS}report/${this.$route.params.native_report_slug}.xlsx`)
                url.searchParams.append("Authorization", `Bearer ${this.$store.state.auth.idToken}`)
                url.searchParams.append("client_id", this.$store.state.auth.profile["custom:client_id"] == 999 && this.$store.state.portalsettings.client ? this.$store.state.portalsettings.client.client_id : this.$store.state.auth.profile["custom:client_id"])
                url.searchParams.append("start_date", this.selected_start_date)
                url.searchParams.append("end_date", this.selected_end_date)

                window.open(url.toString(), "_blank")
            }
            catch (error)
            {
                console.error(error)
            }
        },
    },
    watch: {},
    created() {},
    mounted() {},
}
</script>
  